import React from 'react';
import EditDialog from './templateDialog';
import FieldsDialog from './fieldsDialog';


export default function EditWizard({open, onClose=()=>{}, templateID})
{
    const [wizardPage, setWizardPage] = React.useState(0);

    React.useEffect(() => {
        if(!open)
        {
            setWizardPage(0);
        }
        else
        {
            if(wizardPage === 0)
            {
                setWizardPage(1);
            }
        }
    }, [open, wizardPage]);

    const handleConfirm = () => {
        if(wizardPage >= 3) handleFullClose();
        else setWizardPage(wizardPage+1);
    }

    const handleGoBack = () => {
        setWizardPage(wizardPage-1);
    }

    const handleFullClose = () => {
        onClose();
    }

    // if(!templateID) return null;

    return <>
    <EditDialog open={wizardPage === 1} onClose={handleFullClose} onConfirm={handleConfirm} templateID={templateID}/>
    <FieldsDialog open={wizardPage === 2} onClose={handleFullClose} onCancel={handleGoBack} onConfirm={handleConfirm} templateID={templateID} stepFields={false}/>
    <FieldsDialog open={wizardPage === 3} onClose={handleFullClose} onCancel={handleGoBack} onConfirm={handleConfirm} templateID={templateID} stepFields={true}/>
    </>
}